<flexiform-interpreter *ngIf="leadForm && !sendOk && !thanksHtmlText" 
[schema]="leadForm" 
[logo]="logoUrl"
(onSaveForm)="sendForm($event)"></flexiform-interpreter>
<div *ngIf="(sendOk && thanksHtmlText) || error" class="feedback-section">
    <div class="container">
        <div class="row">
            <div *ngIf="sendOk && thanksHtmlText" class="col-12 col-lg-4 offset-lg-4">
                <div class="logo">
                    <img *ngIf="logoUrl" [src]="logoUrl" alt="logo">
                </div>
                <div [innerHtml]="thanksHtmlText | safeHtml"></div>
            </div>
            <div *ngIf="error" class="col-12 col-lg-4 offset-lg-4">
                <div class="text-center logo">
                    <img *ngIf="logoUrl" [src]="logoUrl" alt="logo">
                </div>
                <div class="text-center"><p>{{error.error.message}}</p></div>
            </div>
        </div>
    </div>
</div>


<onwac-snackbar 
*ngIf="feedback"
[status_class]="snackbar.status_class"
[text]="snackbar.text"
[autoClose]="snackbar.autoClose"
[activate]="snackbar.active"
(hidden)="snackbar.deactivate()"
></onwac-snackbar>
